import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  faAddressBook,
  faCalculator,
  faChartLine,
  faCity,
  faCogs,
  faCog,
  faFolderOpen,
  faHandHoldingUsd,
  faHandshake,
  faHome,
  faQuestion,
  faUniversity,
  faBox,
  faBoxCheck,
  faFileInvoiceDollar,
  faUsers,
  faUser,
  faWallet,
  faClose,
} from '@fortawesome/pro-solid-svg-icons';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/service/data.service';
import { EventEmitterService } from 'src/app/service/event-emitter.service';
import { BreakpointObserverService } from 'src/app/service/mobile-resize.service';
import { ModalDefaultConfirmComponent } from '@wbatd/design-system-wba';
import { SetDataService } from 'src/app/service/set-data.service';
import { GruposService } from 'src/app/service/grupos.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'panel-menu',
  templateUrl: './panel-menu.component.html',
  styleUrls: ['./panel-menu.component.scss'],
})
export class PanelMenuComponent implements OnInit {
  operacional: Boolean = true;
  cadastro: Boolean = true;
  credito: Boolean = true;
  painelComercial: Boolean = true;
  painelGerencial: Boolean = true;
  gestaoCobranca: Boolean = true;
  configuracoes: Boolean = true;
  menuAberto = false;
  mostrar: Boolean = false;
  menus: any;
  menusUsuario: any;
  size$: Observable<string>;
  siteMobile: boolean = false;
  menuMobileFechado: boolean = false;
  iconMenuFechar: any = faClose;

  mostrarMenssagem: boolean = false;
  @Input() menu: any;
  @Output() menuChange = new EventEmitter<any>();
  @Input() visao: string = '';

  listIconesSvg: any = {
    faHandshake,
    faChartLine,
    faQuestion,
    faHandHoldingUsd,
    faCalculator,
    faAddressBook,
    faCogs,
    faCog,
    faFolderOpen,
    faHome,
    faUniversity,
    faCity,
    faBox,
    faBoxCheck,
    faFileInvoiceDollar,
    faUsers,
    faUser,
    faWallet,
  };

  cedenteRecebiveis: any;
  cedenteOperacional: any;
  constructor(
    private dataService: DataService,
    private _breakpointObserverService: BreakpointObserverService,
    private router: Router,
    private usuarioService: GruposService,
    public dialog: MatDialog,
    private setDataService: SetDataService
  ) {
    this.size$ = this._breakpointObserverService.size$;
  }

  ngOnInit() {
    switch (this.visao) {
      case 'cedente':
        this.menus = this.dataService.menus;
        break;
      case 'sacado':
        this.menus = this.dataService.menuSacado;
        break;
      case 'investidor':
        this.menus = this.dataService.menuInvestidor;
        break;
    }

    this.menusUsuario = this.menus;
    this.verificaPermissaoIcon(this.menus);
    EventEmitterService.get('abreMenu').subscribe((data) => {
      this.menuAberto = data;
    });

    this.size$.subscribe((data) => {
      this.siteMobile = false;

      if (data == 'xs' || data == 'sm' || data == 'md') {
        this.siteMobile = true;
      }
    });

    let urlPage = this.router.url;

    // marca o item de menu, quando atualiza a pagina
    if (urlPage) {
      let pathCurrent = urlPage.split('/')[2];
      this.menusUsuario.forEach((m: any) => {
        let menuPath = m.rota.split('/')[2];
        let itemMenu = '';

        // verifica qual /cadastro é o certo, pois tem dois /cadastro
        if (pathCurrent == 'cadastro') {
          if (urlPage.split('/')[3] == 'geral' || urlPage.split('/')[3] == 'grupo') {
            itemMenu = 'CADASTRO';
          } else {
            itemMenu = 'CONFIGURACAO';
          }

          if (m.itemMenu == itemMenu) {
            m.active = true;
          }
          return;
        }

        if (pathCurrent == menuPath) {
          m.active = true;
        }
      });
    }

    this.router.events.subscribe((result) => {
      if (result instanceof NavigationEnd) {
        this.menusUsuario.forEach((m: any) => {
          if (
            !m.itemMenu
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .includes(this.router.url)
          ) {
            m.active = false;
          }
        });
      }
    });
  }
  verificaPermissaoIcon(menu: any) {
    if (menu.descricao == 'Operacional') {
      const CEDENTE_OPERACIONAL = 'CEDENTE_OPERACIONAL';
      this.usuarioService.verificaPermissaoMenu(CEDENTE_OPERACIONAL).then((u: any) => {
        this.setDataService.set(u);
      });
    } else if (menu.descricao == 'Recebíveis') {
      const CEDENTE_RECEBIVEIS = 'CEDENTE_RECEBIVEIS';
      this.usuarioService.verificaPermissaoMenu(CEDENTE_RECEBIVEIS).then((u: any) => {
        this.setDataService.set(u);
      });
      this.setDataService.set(this.cedenteRecebiveis);
    }
  }

  modalErro(error: any) {
    const dialogRef = this.dialog.open(ModalDefaultConfirmComponent, {
      width: '40%',
      data: {
        titulo: 'Falha',
        descricao: error,
        naoExibirNao: true,
        naoExibirSim: true,
      },
    });
    dialogRef.afterClosed().subscribe((dialogObj) => {
      if (dialogObj) {
      }
    });
  }

  iconeSvg(icone: any) {
    return this.listIconesSvg[icone] || this.listIconesSvg.faQuestion;
  }

  abreMenu(event: any) {
    this.menuAberto = true;
    EventEmitterService.get('menuEstaAberto').emit(true);
    event.stopPropagation();
  }

  menuClick() {
    if (this.siteMobile) {
      this.menuAberto = false;
      EventEmitterService.get('abreMenu').emit(false);
    }
  }

  openCloseSubMenu(menu: any) {
    this.menusUsuario.forEach((item: any) => {
      if (item.descricao != menu.descricao) {
        item.click = false;
        item.active = false;
      }
    });

    menu.active = true;
    this.menu = false;
    EventEmitterService.get('abreMenu').emit(false);
  }

  openLink(menu: any) {
    menu.click = false;
    this.menu = false;
    EventEmitterService.get('abreMenu').emit(false);
  }

  redirectSideMenu(rota: string) {
    if (true) {
      this.router.navigate([rota]);
    }
  }

  btMenuChange() {
    this.menu = false;
    this.menuChange.emit(this.menu);
  }
}
